import { Configuration, ProductListsApi } from '@/api';
import Button from '@/components/Button';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import { ProductList, ProductListCreate } from '@/models/ProductList';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import ProductListForm from '@/modules/product/components/ProductListForm';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import { RectangleStackIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

const ProductListEdit = () => {
  const { productListId } = useParams();

  const productListsApi = new ProductListsApi(new Configuration(useAuth));

  const { isLoading, data: productList } = useQuery({
    queryKey: ['productLists', productListId],
    queryFn: async () => {
      return productListId ? productListsApi.getProductList(productListId) : null;
    },
  });

  const handleOnSubmit = (product: ProductListCreate | ProductList): Promise<void> => {
    return new Promise<void>((resolve) => {
      setTimeout(() => {
        console.log(product);
        resolve();
      }, 2000);
    });
  };

  if (isLoading) {
    return (
      <div className="flex justify-center py-20">
        <SpinnerIcon />
      </div>
    );
  }

  if (!productList) {
    return;
  }

  return (
    <>
      <SettingsHeader title="Edit Product List" icon={<RectangleStackIcon className="w-6 h-6" />}>
        <Button
          onClick={() => {}}
          icon={<XMarkIcon className="h-5 w-5 mr-1" aria-hidden="true" />}
          loadingIconClassName="h-5 w-5 mr-1"
          variant="delete"
        >
          Delete Product List
        </Button>
      </SettingsHeader>

      <ProductListForm onSubmit={handleOnSubmit} productList={productList} />
    </>
  );
};

export default ProductListEdit;
